import { useToggle } from "./partials/toggle";
import { useAccordion } from "./patterns/accordion";
import { useMegaNav } from "./patterns/megaNav";
import { usePostFilterForm } from "./patterns/postsFilter";
import { useSlider } from "./patterns/slider";
import { useStickNav } from "./patterns/stickyNav";
import { useTeamCard } from "./patterns/teamCard";
import { useBodySetUp } from "./setup/body";
import { useNavbarCheck } from "./setup/navbarCheck";

function init() {
  console.log("Spruce Custom Theme Loaded");

  // Applies basic set up on body element
  useBodySetUp();

  // Overrides for the navbar
  useNavbarCheck();

  // Add sticky menu support
  useStickNav();

  // Adds mega nav functionality
  useMegaNav();

  // Adds support for using toggles
  useToggle();

  // Adds support for accordion block
  useAccordion();

  // Adds support for slider
  useSlider();

  // Adds support for post filter block
  usePostFilterForm();

  useTeamCard();
}

document.addEventListener("DOMContentLoaded", init);
